import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingExclusionsResponse } from './getListingExclusions';

export default (makeCall: MakeCall) => (
  listingId: number,
  {
    rangeFrom,
    rangeTo,
    dates,
    adjustDates = true,
    actionToken,
  }: ListingExclusionsResponse & {
    adjustDates?: boolean;
    actionToken?: string;
  },
) =>
  makeCall<ListingExclusionsResponse>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: { dates, rangeFrom, rangeTo, adjustDates, actionToken },
    },
  );
